<template><div><h2 id="usage" tabindex="-1" class="d-docsite--header-2">Usage <a class="header-anchor d-link d-docsite--link d-link" href="#usage" aria-hidden="true">#</a></h2>
<p class="d-docsite--paragraph">Use <code v-pre>d-bgg-pattern-{pattern}-{dark|light}</code> to apply a pattern.</p>
<code-example source-code='&lt;dt-stack direction=&quot;row&quot; align=&quot;center&quot; class=&quot;d-w100p d-h-50 d-bar-300 d-bgg-to-br d-ba d-bc-default d-bgc-moderate d-bgg-pattern d-bgg-pattern-slanted-stripes-dark d-fc-primary&quot;&gt;Ted&#39;s Call Center&lt;/dt-stack&gt;
&lt;dt-stack direction=&quot;row&quot; align=&quot;center&quot; class=&quot;d-w100p d-h-50 d-bar-300 d-bgg-to-br d-ba d-bc-default d-bgc-moderate d-bgg-pattern d-bgg-pattern-chevrons-dark&quot;&gt;Vicky&#39;s Department&lt;/dt-stack&gt;'>
<dt-stack direction="row" align="center" class="d-w100p d-h-50 d-bar-300 d-bgg-to-br d-ba d-bc-default d-bgc-moderate d-bgg-pattern d-bgg-pattern-slanted-stripes-dark d-fc-primary">Ted's Call Center</dt-stack>
<dt-stack direction="row" align="center" class="d-w100p d-h-50 d-bar-300 d-bgg-to-br d-ba d-bc-default d-bgc-moderate d-bgg-pattern d-bgg-pattern-chevrons-dark">Vicky's Department</dt-stack>
</code-example>
<h2 id="classes" tabindex="-1" class="d-docsite--header-2">Classes <a class="header-anchor d-link d-docsite--link d-link" href="#classes" aria-hidden="true">#</a></h2>
<utility-class-table>
  <template #content>
    <tbody v-for="c in ['dark', 'light']">
      <tr v-for="i in ['blob', 'chevrons', 'crosses', 'crosshatch', 'dot-dash', 'dots-circles', 'horz-stripes', 'slanted-stripes', 'steps', 'stripe']">
        <th scope="row" class="d-code--sm d-docsite-code">.d-bgg-pattern-{{ i }}-{{ c }}</th>
        <td>
          <dt-stack direction="row" justify="between" align="center">
            <div class="d-fl-grow1 d-code--sm">
              --bgg-pattern: --bgg-pattern-{{ i }}-{{ c }};
            </div>
            <div
              class="d-size-50 d-bgg-pattern d-ba d-bc-black-900 d-bar-300"
              :class="[
                  {'d-bgc-neutral-white': c === 'dark'},
                  {'d-bgc-neutral-black': c === 'light'},
                  `d-bgg-pattern-${i}-${c}`
              ]"
            >
            </div>
          </dt-stack>
        </td>
      </tr>
    </tbody>
  </template>
</utility-class-table>
</div></template>


